import { ReactNode, useMemo } from "react"
import cn from "classnames"

import styles from "./styles.module.scss"

import { Psychologist } from "utils/interfaces"
import { ImgAvatar, NonImgAvatar, Sizes } from "components/Avatar"
import { getFaceUrl, psychologistTitles } from "utils/helpers/psychologistUtil"
import { capitalize } from "utils/utils"

export function PsychologistAvatar({
    psy,
    size,
    renderAfter,
    className,
    imgClassName,
    ...props
}: {
    psy: Psychologist
    size?: Sizes
    renderAfter?: ReactNode
    className?: string
    imgClassName?: string
}) {
    const faceUrl = getFaceUrl(psy.face_url, psy.hash_id)
    const avatarAlt = useMemo(() => {
        let value = `${psy.display_name}, `
        psychologistTitles(psy).forEach((title, index) => {
            value += `${capitalize(title)}`
            if (psy.titles.length !== 0 && psy.titles.length - 1 !== index) {
                value += ", "
            }
        })
        return value
    }, [psy])

    if (faceUrl == " ") {
        return null
    }

    return (
        <div className={cn(styles.psychologistAvatar, className)} {...props}>
            <ImgAvatar
                src={faceUrl}
                alt={avatarAlt}
                size={size}
                className={imgClassName}
                fallback={() => (
                    <NonImgAvatar size={size} className={imgClassName}>
                        {psy.display_name}
                    </NonImgAvatar>
                )}
            />
            {renderAfter}
        </div>
    )
}
